import { createListenerMiddleware } from '@reduxjs/toolkit';
import { generateDynamicPath } from 'common/utils';
import { addAppAlertDialog, addAppInfoMessage } from 'modules/alerts/state';
import { AppRoutes } from 'modules/router';
import { push } from 'redux-first-history';
import type { RootState } from 'store';
import { handleQueryError } from 'store/utils';

import {
  InsightsReportStatus,
  createInsightsReportsRejectedEffect,
  createInsightsReportsSucceededEffect,
} from '../insightsReport';
import { surveyReportApi } from './surveyReportApi';

export const surveyReportApiLister = createListenerMiddleware<RootState>();

surveyReportApiLister.startListening({
  matcher: surveyReportApi.endpoints.createSurveysReport.matchFulfilled,
  effect: createInsightsReportsSucceededEffect,
});

surveyReportApiLister.startListening({
  matcher: surveyReportApi.endpoints.createSurveysReport.matchRejected,
  effect: createInsightsReportsRejectedEffect,
});

surveyReportApiLister.startListening({
  matcher: surveyReportApi.endpoints.deleteSurveyReport.matchFulfilled,
  effect: ({ meta }, { dispatch }) => {
    const { name, status } = meta.arg.originalArgs;

    if (status === InsightsReportStatus.Error) {
      dispatch(addAppInfoMessage(`${name} successfully deleted`));
    } else {
      dispatch(
        addAppAlertDialog({
          title: 'Report Successfully Deleted',
          description: `Your Report ${name} was successfully deleted from the Reports List.`,
          confirmLabel: 'Ok',
        })
      );
    }

    dispatch(push(generateDynamicPath(AppRoutes.InsightsReportSurveyById)));
  },
});

surveyReportApiLister.startListening({
  matcher: surveyReportApi.endpoints.deleteSurveyReport.matchRejected,
  effect: ({ payload, type, meta }, { dispatch }) => {
    const { name } = meta.arg.originalArgs;
    handleQueryError(payload, dispatch, type, `Unable to delete Report "${name}"`);
  },
});

surveyReportApiLister.startListening({
  matcher: surveyReportApi.endpoints.retrySurveyReportGeneration.matchFulfilled,
  effect: (_result, { dispatch }) => {
    dispatch(
      addAppAlertDialog({
        title: 'We Are Creating Your Report',
        description: `We’ll notify you via email as soon as it's ready!`,
        confirmLabel: 'Got it',
      })
    );
  },
});

surveyReportApiLister.startListening({
  matcher: surveyReportApi.endpoints.retrySurveyReportGeneration.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(
      payload,
      dispatch,
      type,
      'Report creation unsuccessful. Please retry, or contact support@natter.co if the issue persists.'
    );
  },
});
